import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable react/jsx-pascal-case */
import Usp from './usp-tag';
import ProductTable from './elements';
import sw from '@uswitch/ev-utils/switch';
import { getValue } from './utils';
import EligibilityInformation from './eligibility-information';
import DropDown from './dropdown';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
export var AddonComponent = sw({
  'addons.Usp': function addonsUsp(_ref) {
    var addon = _ref.addon,
        data = _ref.data;
    var usps = getValue(addon.usp, data);
    return [].concat(usps).slice(0, addon.max || Infinity).map(function (usp, index) {
      return _jsx(ProductTable.cells.Base, {
        sx: {
          display: 'block'
        },
        mobileOrder: -200,
        children: _jsx(Usp, {
          usp: usp
        }, usp)
      }, index);
    });
  },
  'addons.Footer': function addonsFooter(_ref2) {
    var _addon$label;

    var addon = _ref2.addon,
        data = _ref2.data;
    var footer = getValue(addon.footer, data);
    return _jsx(ProductTable.cells.Base, {
      extraRules: {
        display: 'block',
        fontSize: 'sm'
      },
      mobileOrder: 100,
      children: (_addon$label = addon.label) !== null && _addon$label !== void 0 && _addon$label.trim() && footer !== null && footer !== void 0 && footer.trim() ? [_jsx("div", {
        sx: {
          variant: 'compounds.product-table.variants.redesign.addonFooter.label'
        },
        children: addon.label
      }, "0"), footer] : null
    });
  },
  'addons.Info': function addonsInfo(_ref3) {
    var addon = _ref3.addon,
        data = _ref3.data;
    return _jsx(ProductTable.cells.Base, {
      extraRules: {
        display: 'block',
        fontSize: 'xs'
      },
      mobileOrder: 99,
      children: addon.info ? [_jsx("div", {
        sx: {
          variant: 'compounds.product-table.variants.redesign.addonInfo.label'
        },
        children: addon.label
      }, "0"), addon.info.map(function (item, key) {
        return _jsx("div", {
          children: getValue(item, data)
        });
      }, this)] : null
    });
  },
  'addons.EligibilityCriteria': function addonsEligibilityCriteria(_ref4) {
    var addon = _ref4.addon,
        data = _ref4.data,
        onClickEligibility = _ref4.onClickEligibility;
    var title = getValue(addon.title, data);
    var content = addon.content;
    var variant = addon.headerImage ? 'eligibility-criteria-redesign' : 'eligibility-criteria';

    var onClick = function onClick() {
      onClickEligibility && onClickEligibility(addon);
    };

    return _jsx(ProductTable.cells.Base, {
      extraRules: {
        display: 'block',
        fontSize: 'xs',
        marginLeft: ['-8px', '-16px'],
        marginRight: ['-8px', '-16px'],
        marginBottom: '-40px',
        borderTop: 'none',
        paddingTop: 'none',
        marginTop: 'none'
      },
      mobileOrder: 100,
      children: _jsx(DropDown, {
        title: title,
        variant: variant,
        children: _jsx(EligibilityInformation, {
          content: content,
          data: data,
          headerImage: addon.headerImage,
          onClick: onClick
        })
      })
    });
  },
  'addons.Image': function addonsImage(_ref5) {
    var addon = _ref5.addon,
        data = _ref5.data;
    var image = getValue(addon.image, data);
    var alt = getValue(addon.alt, data);
    return _jsx(ProductTable.cells.Image, {
      children: _jsx("img", {
        src: image,
        alt: alt,
        sx: {
          width: '100%',
          objectFit: 'cover'
        }
      })
    });
  },
  default: function _default(_ref6) {
    var addon = _ref6.addon,
        data = _ref6.data;
    console.error('Warning! Did not find addon');
    console.error(addon);
    return null;
  }
});
export var AddonPosition = sw({
  'addons.position.Footer': function addonsPositionFooter(_ref7) {
    var _addon$options, _addon$options2;

    var addon = _ref7.addon;
    return {
      addon: ProductTable.addons.footer,
      options: {
        split: (_addon$options = addon.options) === null || _addon$options === void 0 ? void 0 : _addon$options.split,
        headerImage: (_addon$options2 = addon.options) === null || _addon$options2 === void 0 ? void 0 : _addon$options2.headerImage
      }
    };
  },
  'addons.position.Info': function addonsPositionInfo(_ref8) {
    var _addon$options3, _addon$options4;

    var addon = _ref8.addon;
    return {
      addon: ProductTable.addons.info,
      options: {
        split: (_addon$options3 = addon.options) === null || _addon$options3 === void 0 ? void 0 : _addon$options3.split,
        headerImage: (_addon$options4 = addon.options) === null || _addon$options4 === void 0 ? void 0 : _addon$options4.headerImage
      }
    };
  },
  'addons.position.EligibilityCriteria': {
    addon: ProductTable.addons.accordion
  },
  'addons.position.Responsive': {
    addon: ProductTable.addons.responsive,
    options: {
      positions: ['body', 'header']
    }
  },
  'addons.position.Image': {
    addon: ProductTable.addons.responsive,
    options: {
      headerOrder: -1,
      gridOrder: -1,
      positions: ['header', 'grid']
    }
  },
  default: {
    addon: ProductTable.addons.responsive,
    options: {
      positions: ['body', 'header']
    }
  }
});
export default (function () {
  var addons = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var data = arguments.length > 1 ? arguments[1] : undefined;
  var onClickEligibility = arguments.length > 2 ? arguments[2] : undefined;
  return addons.map(function (addon) {
    return _objectSpread({
      component: AddonComponent(addon.type, {
        addon: addon,
        data: data,
        onClickEligibility: onClickEligibility
      })
    }, AddonPosition(addon.position, {
      addon: addon,
      data: data
    }));
  });
});
//# sourceMappingURL=addons.js.map